<template>
    <div class="vue-template">
      <h2 style="padding-start:20px;">{{msg}}</h2>
      <br>

      <div align="left">
        <scale-loader :loading="loading"></scale-loader>
      </div>

      <button class="btn btn-dark btn-lg btn-block" :disabled="goBackDisabled" @click="goBack()">Done</button>

    </div>
</template>


<script>
import firebase from "firebase/app"
import 'firebase/auth'
import axios from "axios"
import ScaleLoader from "@/components/ScaleLoader"

import { Plugins } from "@capacitor/core";
const { Storage } = Plugins
// const { Network } = Plugins



export default {
  name: "SendCheckin",

  components: {
    ScaleLoader,
  },

  data() {
    return {
      msg: "Please wait. Checkin in Progress....",
      loading: false,
      goBackDisabled: true,
    };
  },

  created() {

  },

  mounted(){
      var userId = this.$route.params.userId
      var imgB64 = this.$route.params.imgB64
      var lat = this.$route.params.lat
      var long = this.$route.params.long

      // Submit current request - deviceUserOrg, , userId, lat, long, imgB64, checkinTime, pendingReqKey
      this.checkinRequest('', userId, lat, long, imgB64, '', '')
  },

  methods: {
    goBack() {
      self.goBackDisabled = true
      this.$router.go(-1);
    },


    async checkinRequest(deviceUserOrg, userId, lat, long, imgB64, checkinTime, pendingReqKey){
      var self=this
      if (this.$parent.onlineStatus == 'OffLine'){
        //self.$alert("No internet connection. Please try after some time.")
        console.log("No internet connection. Saving checkins to local storage")

        // Save checkin to local storage
        var pendingCheckins = self.getPendingCheckins()
        checkinTime = Date.now() / 1000
        console.log(checkinTime)
        console.log(lat + "," + long)
        pendingCheckins.push({'id':userId, 'callerLat': lat, 'callerLon': long, 'img': '', 'checkinTime': checkinTime})
        self.setPendingCheckins(pendingCheckins)

        self.msg = "Checkin completed. Thank you."
        self.goBackDisabled = false
        return
      }

      // For previously failed entries, deviceUserOrg is already set
      if (deviceUserOrg == ""){
        const orgIdObject = await Storage.get({ key: 'tk3_checkin_orgId' })
        deviceUserOrg = orgIdObject.value
      }

      var deviceUserId = ""
      var deviceUserToken = ""

      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          deviceUserId = user.email
          user.getIdToken().then(token => {
                      //handle token
                      deviceUserToken = token
                      this.postCheckinRequest(deviceUserId, deviceUserOrg, userId, lat, long, imgB64, checkinTime, pendingReqKey, deviceUserToken)
                    })
        } else {
          this.$router.push('/login')
        }
      })
    },

    async postCheckinRequest(deviceUserId, deviceUserOrg, userId, lat, long, imgB64, checkinTime, pendingReqKey, deviceUserToken){
      var self = this
      
      // Set loading message
      self.loading = true
      self.goBackDisabled = true

      var postData = new FormData()

      postData.append("id", userId)
      postData.append("orgId", deviceUserOrg)
      postData.append("imei", deviceUserId)
      postData.append("callerLat",  lat)
      postData.append("callerLon",  long)
      postData.append("img", imgB64)
      postData.append("checkinTime", checkinTime)
      postData.append("pendingCheckins", JSON.stringify(self.getPendingCheckins()))
      // Bakward compatibility with old app
      postData.append("authKey", "")

      axios({
          method: 'POST',
          baseURL: process.env.VUE_APP_ROOT_API,
          url: '/AddInOutEntry/',
          data: postData,
          headers: {
            'Authorization': 'Bearer ' + deviceUserToken,
            'Content-Type': 'application/x-www-form-urlencoded',
          }
        })
        .then(function (response) {
          if (response.data.err != '') {
            console.log(response.data.err)
            // Reset loading message
            self.loading = false
            self.msg = "Checkin failed. " + response.data.err
            self.goBackDisabled = false
          }
          else {
            // Reset loading message
            self.loading = false
            if (lat==0 && long==0)
              self.msg = "Checkin completed without location. Please enable location service."
            else
              self.msg = "Checkin completed. Thank you."
            self.goBackDisabled = false
            // Reset pendingCheckins
            self.setPendingCheckins([])
          }
        })
        .catch(function (error) {
          console.log(String(error))
          // Reset loading message
          self.loading = false
          self.msg = String(error) + ". Checkin entry saved."
          self.goBackDisabled = false
        })

    },

  },


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
